import IaprcWelcome from "./_components/welcome"
import IaprcDiscount from "./_components/discount"
import Footer from "../../components/marketing/footer/Footer"

export default function IAPRCPage() {
  return (
    <>
      <IaprcWelcome />
      <IaprcDiscount />
      <Footer />
    </>
  )
}
